import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {AlertService} from "../services";
import {Subject} from "rxjs";
import {locale as polish} from "./i18n/pl";
import {locale as english} from "./i18n/en";
import {FuseTranslationLoaderService} from "../../../@fuse/services/translation-loader.service";
import {ComponentTitleService} from "../services/componentTitle.service";
import {first} from "rxjs/operators";
import {Page} from "../models/page";
import {DatatableComponent} from "@swimlane/ngx-datatable";
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {DateRange} from "../models/dateRange";
import {MatDialog} from "@angular/material/dialog";
import {VoucherTemplateGroupList} from "../models/voucherTemplateGroupList";
import {StockService} from "../services/stock.service";
import {StockList} from "../models/stockList";
import {ActivatedRoute, Router} from "@angular/router";
import {StockChangeService} from "../services/stockChange.service";
import {Stock} from "../models/stock";

@Component({
    templateUrl: './stock.component.html',
    styleUrls: ['./stock.component.scss']
})
export class StockComponent implements OnDestroy, OnInit {
    rows: any[];
    loadingIndicator: boolean;
    reorderable: boolean;
    dateRange: DateRange;
    deleteDialogRef: any;
    stocks: Stock[];

    page = new Page();
    @ViewChild(DatatableComponent) table: DatatableComponent;

    // Private
    private _unsubscribeAll: Subject<any>;

    constructor(
        private stockService: StockService,
        private stockChangeService: StockChangeService,
        private alertService: AlertService,
        private translationLoader: FuseTranslationLoaderService,
        private componentTitleService: ComponentTitleService,
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        public _matDialog: MatDialog,
    ) {
        // Set the defaults
        this.loadingIndicator = true;
        this.reorderable = true;
        this.page.pageNumber = 0;
        this.page.size = 10;

        // Set the private defaults
        this._unsubscribeAll = new Subject();

        this.translationLoader.loadTranslations(polish, english);

        componentTitleService.clearTitle();
        componentTitleService.addPart('Stocks');
    }

    ngOnInit() {
        this.stockService.getAll(0, 100, this.route.snapshot.params['id']).pipe(first())
            .subscribe((res: StockList) => {
                    this.stocks = res.items;
                },
                error => {
                    this.alertService.error(error);
                })

        this.setPage({offset: 0});
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    setPage(pageInfo) {
        this.loadingIndicator = true;
        this.rows = [];
        this.page.totalElements = 0;
        this.page.pageNumber = pageInfo.offset;

        if (typeof pageInfo.limit === "undefined") {
            pageInfo.limit = this.page.size;
        }

        this.stockChangeService.getAll(pageInfo.offset * pageInfo.limit, pageInfo.limit, this.route.snapshot.params['id']).pipe(first())
            .subscribe((res: StockList) => {
                    this.rows = res.items;
                    this.loadingIndicator = false;
                    this.page.totalElements = res.total;
                    // this.page = pagedData.page;
                },
                error => {
                    this.alertService.error(error);
                });
    }
}
